﻿import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { GetUserModel, GetUserStatusModel, UserListIndexModel } from "../../../model/jubili/user-manage/get-users";
import { AutoResetPasswordModel, AutoResetPasswordResultModel } from "../../../model/jubili/user-manage/auto-reset-password";
import { apiLink } from "../../../constant/api-link";

@Injectable({
  providedIn: "root"
})
export class UserManageService {

    constructor(
        private http: HttpClient
    ) { }

    // get userlist (sort,search,filter)
    getAllUserBackOffice(getuser: GetUserModel): Observable<UserListIndexModel> {

      // ${environment.apiJubiliURL}api/V1/UserSetting/GetListUserBackOffice/
        const url = apiLink.getUserList;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.post<UserListIndexModel>(url, getuser, { headers });
    }

    getCountUserStatusBackOffice(searchcompanyname: string, searchusername: string, status:string): Observable<Array<GetUserStatusModel>> {

      // ${environment.apiJubiliURL}api/V1/UserSetting/GetListUserBackOffice/
        const url = apiLink.getCountUserStatus;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        let params = new HttpParams()
        .set('CompanynameSearch', searchcompanyname)
        .set('UsernameSearch', searchusername)
        .set('status', status);

        return this.http.get<Array<GetUserStatusModel>>(url, { headers, params: params });
    }

    // reset password ลูกค้าผ่าน JUBILI ที่ proxy ไป BuilkAuth อีกที
    // token แนบให้เองโดย InterceptorService
    autoResetPassword(actorUserSurrKey: number, actorEmail: string, targetEmail: string)
        : Observable<AutoResetPasswordResultModel> {

        const url = apiLink.autoResetPassword;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        // normalize ก่อนส่ง - actorEmail มาจากช่อง login ที่ CS พิมพ์เอง จึงติดตัวพิมพ์ใหญ่
        // หรือช่องว่างมาได้ (BE เทียบแบบ case-insensitive อยู่แล้ว นี่เป็นการกันอีกชั้น)
        const body: AutoResetPasswordModel = {
            actorUserSurrKey: actorUserSurrKey,
            actorEmail: (actorEmail || "").trim().toLowerCase(),
            targetEmail: (targetEmail || "").trim().toLowerCase()
        };

        return this.http.post<AutoResetPasswordResultModel>(url, body, { headers });
    }
}
